import { CloseOutlined, WarningFilled } from "@ant-design/icons";
import styled from "styled-components"

const Style = styled.div`
  .pop-header {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }

  .body {
    margin-top: 10px;

    .title {
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 2px;
    }

    .body-p {
      color: #667085;
      font-weight: 500;
      font-size: 14px;
    }
  }

  .buttons {
    display: flex;
    gap: 12px;

    span {
      font-size: 14px;
      font-weight: 600;
      color: #667085;

      &.link {
        color: var(--color-primary-70);
      }
    }
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .flex-c {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .icon {
    border-radius: 100%;
    background: #FFFAEB;
    width: 35px;
    height: 35px;

    .icon-body {
      margin-left: auto;
      margin-right: auto;
      width: 26px !important;
      height: 26px !important;
      background: #FEF0C7;
      border-radius: 100%;

      svg {
        margin-left: auto;
        margin-right: auto;
        color: #FEC84B;
        width: 15px;
        height: 15px;
        font-size: 15px;
        margin: 0px;
        padding: 0px;
      }
    }
  }

`;

export default function RemovePopoverContent({
  title = 'Are you sure you want to remove this source?',
  body = 'Its information will be removed from the project.',
  okText = 'Yes',
  dismissText = 'Dismiss',
  onClose = () => { },
  onConfirm = () => { },
}) {
  return (
    <Style>
      <div className="pop-header">
        <div className="icon flex-c icon-warning" >
          <div className="icon-body flex-c">
            <WarningFilled />
          </div>
        </div>
        <div className="flex-c cursor-pointer">
          <CloseOutlined onClick={onClose} style={{ fontSize: 12 }} />
        </div>
      </div>
      <div className="body">
        <p className="title">{title}</p>
        <p className="body-p">{body}</p>
      </div>
      <div className="buttons">
        <span className="cursor-pointer" onClick={onClose}>
          {dismissText}
        </span>
        <span className="link cursor-pointer" onClick={onConfirm}>
          {okText}
        </span>
      </div>
    </Style>
  );
}
